import Types from '../../reducers/app/types';

export default constants => ({
  type: Types.SET_FEATURE_FLAGS,
  payload: constants,
});
